import {loadStripe} from '@stripe/stripe-js';
import {Elements} from '@stripe/react-stripe-js';
import { PaymentForm } from "./PaymentForm";

export const Payment = () => {
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
    const options = {
      appearance: {/*...*/},
    };
  
  return (
    <Elements stripe={stripePromise} options={options}>
      <PaymentForm/>
    </Elements> 
  );
};
